import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  Text,
  Icon,
  Input,
  Radio,
  Modal,
  Popover,
  Menu,
  Dropdown,
} from "antd";
import ButtonComponent from "./Button_v2";

import Checkbox_v2 from "./Checkbox_v2";
import SectionCard from "./SectionCard";
import { ViewMore } from "../../common/CustomIcon";
import I18n from "../../common/I18n";
import TrashIcon from "../../../assets/images/Trash.svg";
import NoteIcon from "../../../assets/images/Note.svg";
import { getWarehouseAccessorials, saveWarehouseAccessorials } from "../../api/Accessorials";
import Search_v2 from "./Search_v2";
import Modal_v2 from "./Modal_v2";
import Button_v2 from "./Button_v2";
import { renderAlertMessage } from "../../helpers/common";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
import { alertMessage } from "../../common/Common";

const { confirm } = Modal;

function WarehouseAccessorials(props) {
  const { savedRecords = [], accountId = "", actionType = "create", currentOrg, currentOrder, isShipper = false, showActions = true,onAccessorialsSave  } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [accessorials, setAccessorials] = useState([]);
  const [filteredAccessorials, setFilteredAccessorials] = useState([]);
  const [selectedAccessorials, setSelectedAccessorials] = useState([
    ...savedRecords,
  ]);
  const [prevSelectedAccessorials, setPrevSelectedAccessorials] = useState([
    ...savedRecords,
  ]);

  useEffect(() => {
    getAccountWarehouseAccessorials();
  }, [accountId]);

  const getAccountWarehouseAccessorials = () => {
    if (accountId) {
      getWarehouseAccessorials(accountId).then((result) => {
        if (result.success) {
          setAccessorials(result.warehouseAccessorials || []);
          setFilteredAccessorials(result.warehouseAccessorials || []);
        } else {
          setAccessorials([]);
          setFilteredAccessorials([]);
        }
      });
    }
  };

  const openModal = () => {
    setFilteredAccessorials([...accessorials])
    setSelectedAccessorials([...prevSelectedAccessorials])
    setIsModalOpen(true);
  };

  const renderSelectedAccessorial = () => {
    const [visibleOptions, setVisibleOptions] = useState({});
    const handleViewMoreClick = (id) => {
      setVisibleOptions((prevState) => ({
        ...prevState,
        [id]: !prevState[id],
      }));
    };
    const handleVisibleChange = (id, flag) => {
      setVisibleOptions((prevState) => ({
        ...prevState,
        [id]: flag,
      }));
    };
    const handleRemoveClick = (id) => {
      handleSave(prevSelectedAccessorials.filter(code => code !== id))
    };
    const menu = (id) => (
      <Menu>
        <Menu.Item
          key="0"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            fontSize: "14px",
          }}
          onClick={() => handleRemoveClick(id)}
          data-testid="remove-accessorial"
        >
          <img src={TrashIcon} alt="" />
          <span>Remove</span>
        </Menu.Item>
      </Menu>
    );

    return accessorials
      .filter((acc) => prevSelectedAccessorials.includes(acc.accessorial_code))
      .map((acc) => (
        <Row key={acc.id} className="accessorialRow" type="flex" gutter={8}>
          <Col xs={10} className="blkCenterLeft fontSize14">
            {acc.accessorial_name}
          </Col>
          {showActions && <Col xs={14} className="alignRight blkCenterRight">
            <Row type="flex" justify="end" gutter={8}>
              <Col className="blkCenterRight" data-testid="dropdown-options">
                <ViewMore
                  key={acc.accessorial_code}
                  onClick={() => handleViewMoreClick(acc.accessorial_code)}
                />
              </Col>
            </Row>
            <Dropdown
              key={acc.accessorial_code}
              placement="bottomLeft"
              overlay={() => menu(acc.accessorial_code)}
              trigger={["click"]}
              visible={visibleOptions[acc.accessorial_code] || false}
              onVisibleChange={(flag) =>
                handleVisibleChange(acc.accessorial_code, flag)
              }
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedAccessorials(
                    selectedAccessorials.filter(
                      (acc) => acc.accessorial_code !== id
                    )
                  );
                }}
              />
            </Dropdown>
          </Col>}
        </Row>
      ));
  };

  const handleOnChangeDirect = (code, value) => {
    if (value) {
      setSelectedAccessorials([...selectedAccessorials, code]);
    } else {
      setSelectedAccessorials(
        selectedAccessorials.filter((key) => key !== code)
      );
    }
  };

  const handleSearch = (val) => {
    if (val) {
      setFilteredAccessorials(
        accessorials.filter((item) =>
              item.accessorial_name.toLowerCase().includes(val.toLowerCase()) ||
              item.accessorial_code.toLowerCase().includes(val.toLowerCase())
          )
        )
    } else {
      setFilteredAccessorials([...accessorials]);
    }
  };
const handleSave = (selectedAccessorials) => {
  if (actionType === "create") {
    // Directly update the selected accessorials without an API call
    setPrevSelectedAccessorials(selectedAccessorials);
    onAccessorialsSave(selectedAccessorials);
    setIsModalOpen(false);
  } else {
    const orderAccessorials = [
      {
        order_id: currentOrder?.id || "",
        accessorials: [...selectedAccessorials],
      },
    ];
    const data = {
      required_accessorials: [...orderAccessorials],
      organization_id: currentOrg?.id || "",
    };
    setIsLoading(true);

    saveWarehouseAccessorials(data).then((result) => {
      if (result.success) {
        setIsLoading(false);
        setPrevSelectedAccessorials(selectedAccessorials);
        renderNotification(result.message || "Saved Successfully", "success");
        setIsModalOpen(false);
      } else {
        alertMessage(result.errors, "error", 10);
      }
    });
  }
};

  const selectAccessorialModalFooter = () => {
    return (
      <Row type="flex" justify="end">
        <Col>
          <Button_v2
            data-testid="cancel-warehouse-accessorial-button"
            onClick={() => setIsModalOpen(false)}
            className="flat medium-btn"
            text="Cancel"
          />
          <Button_v2
            data-testid="save-warehouse-accessorial-button"
            disabled={_.isEmpty(selectedAccessorials)}
            onClick={() => {
              handleSave(selectedAccessorials)
            }}
            className="raised medium-btn"
            text={`Add (${selectedAccessorials.length}) Accessorial`}
            loading={isLoading}
          />
        </Col>
      </Row>
    );
  };
  const renderAccessorialForm = () => {
    return (
      <Modal_v2
        visible={isModalOpen}
        title="Add Accessorial "
        footer={selectAccessorialModalFooter()}
        content={
          <div>
            <Search_v2
              data-testid="search-accessorials-input"
              placeholder="Search Accessorial"
              onSearch={handleSearch}
            />
            <div className="createOrderAccessorial marginTop20" data-testid="accessorials-list">
              {filteredAccessorials.map((acc) => (
                <Row
                  key={acc.code}
                  className="accessorialRow"
                  type="flex"
                  // gutter={8}
                >
                  <Col xs={24} className="blkCenterLeft" data-testid="checkbox-accessorial">
                    <Checkbox_v2
                      handleChange={(value) =>
                        handleOnChangeDirect(acc.accessorial_code, value)
                      }
                      label={acc.accessorial_name}
                      checkValue={selectedAccessorials?.includes(
                        acc.accessorial_code
                      )}
                    />
                  </Col>
                </Row>
              ))}
            </div>
          </div>
        }
        width={720}
        closable={false}
      />
    );
  };

  return (
    <div className="createOrderAccessorial">
      <SectionCard
        title={<Fragment>{I18n.t('general.warehouse')} Accessorial</Fragment>}
        extraActionNode={
          showActions && (
            <ButtonComponent
              data-testid="add-accessorial-button"
              style={{ borderRadius: "4px" }}
              text={"Add Accessorial"}
              type="secondary"
              className="outline small-btn"
              onClick={openModal}
            />
          )
        }
      >
        {renderSelectedAccessorial()}
      </SectionCard>
      {isModalOpen && renderAccessorialForm()}
    </div>
  );
}

export default WarehouseAccessorials;
